import React from 'react';
import PropTypes from 'prop-types';
import useLastRowDetection from '../../../hooks/useLastRowDetection';
import OptionInput from '../../OptionButton';
import { WrapperSection, Title, WrapperSubTypesInputs } from './styles';
import { useTranslation } from 'react-i18next';

const PropertySubType = ({ device, register, setValue, propertySubTypeOptions = [], selectedPropertySubType }) => {
  const { t } = useTranslation();
  const hasPropertySubTypeOptions = propertySubTypeOptions?.length > 0;
  const { containerRef, lastRowIndexes } = useLastRowDetection([hasPropertySubTypeOptions]);
  const handleClick = e => {
    const { value, name } = e.target;
    setValue(name, selectedPropertySubType === value ? null : value);
  };

  return (
    hasPropertySubTypeOptions && (
      <WrapperSection data-publi='mainData-propertySubType'>
        <Title data-publi='mainData-propertySubType-title'>{t('professionalPubli.main.subPropertyType')}</Title>
        <WrapperSubTypesInputs
          ref={containerRef}
          device={device}
          active={hasPropertySubTypeOptions}
          marginTop='0'
          data-publi='propertySubType-others'
        >
          {propertySubTypeOptions?.map((property, index) => (
            <OptionInput
              key={property?.realEstateSubTypeId}
              type='radio'
              name='propertySubType'
              value={property?.realEstateSubTypeId}
              selected={selectedPropertySubType === property?.realEstateSubTypeId}
              onClick={handleClick}
              label={property?.name}
              register={register}
              flexWidth={!lastRowIndexes.includes(index)}
              padding='0 4px'
              withTooltip
              dataLabel={`${index + 1}`}
            />
          ))}
        </WrapperSubTypesInputs>
      </WrapperSection>
    )
  );
};

PropertySubType.propTypes = {
  device: PropTypes.string.isRequired,
  register: PropTypes.func.isRequired,
  setValue: PropTypes.func.isRequired,
  propertySubTypeOptions: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      realEstateSubTypeId: PropTypes.string.isRequired
    })
  ),
  selectedPropertySubType: PropTypes.string
};

export { PropertySubType };
